import { array } from 'prop-types';
import { map } from 'lodash';
import { textFormatter } from 'utils';

import './style.scss';

export default function BreadCrumb(props) {
	const { path } = props;

	const list = map(path, (el, i) => {
		return <li key={i}>{textFormatter(el)}</li>;
	});

	return (
		<>
			<ul className='bread-crumbs'>{list}</ul>
		</>
	);
}

BreadCrumb.propTypes = {
	path: array
};

BreadCrumb.defaultProps = {
	path: []
};
